import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(0, 3, 3),
    '& .MuiGrid-item': {
      '& .MuiGrid-container:nth-child(2)': {
        gap: spacing(3)
      }
    }
  },
  saveBtn: {
    marginTop: spacing(4)
  },
  popmenu: {
    width: '100%',
    maxWidth: 330
  },
  featContainer: {
    margin: spacing(2, 0)
  },
  formCtn: {
    padding: spacing(2),
    '& > div:not(:last-child)': {
      marginBottom: spacing(1)
    }
  },
  ctnControls: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: spacing(2, 0),
    '& > button:not(:last-child)': {
      marginRight: spacing(1)
    }
  },
  msaAccordion: {
    '&:before': {
      display: 'none'
    }
  },
  msaAccordionExpanded: {
    margin: '0 !important'
  },
  msaAccordionSummary: {
    height: 55,
    paddingLeft: '1.5rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  msaSubtitleMap: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  msaScoreLabel: {
    fontSize: 12,
    paddingRight: 5,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  msaScoreInput: {
    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-input': {
        padding: '10px 15px'
      }
    }
  }
}))
